/* Original ILS film. A source is attached only when playback is appropriate. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ils-film]:not([data-film-ready])').forEach(figure => {
      figure.dataset.filmReady = 'true';
      const video = figure.querySelector('video');
      const button = figure.querySelector('[data-film-toggle]');
      const status = figure.querySelector('[data-film-status]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const small = matchMedia('(max-width: 749px)'); // matches the 4:5 phone hero
      const touch = matchMedia('(pointer: coarse)');
      const connection = navigator.connection;
      let visible = false, userPaused = false, attempted = false, pending = false;
      let resume = false, manual = false, failed = false, request = 0, timeout;
      // Muted inline autoplay on every screen size; reduced-motion and data-saving visitors still choose.
      const allowed = () => figure.dataset.autoplay === 'true' && !motion.matches && !connection?.saveData;
      const label = (text, icon) => {
        button.replaceChildren(document.createTextNode(text + ' '));
        const mark = document.createElement('span');
        mark.ariaHidden = 'true'; mark.textContent = icon; button.append(mark);
      };
      const update = () => label(pending ? 'Cancel loading' : video.paused ? 'Play film' : 'Pause film', pending ? '×' : video.paused ? '▷' : 'Ⅱ');
      const pause = () => {
        const cancelDownload = pending && video.readyState < 2;
        request++; clearTimeout(timeout); pending = false; video.pause();
        if (cancelDownload) { video.removeAttribute('src'); video.load(); }
        update();
      };
      const play = async (fromUser = false) => {
        if (pending) return;
        manual = fromUser;
        userPaused = false;
        attempted = true;
        if (failed) { video.removeAttribute('src'); video.load(); failed = false; }
        if (!video.getAttribute('src')) video.src = small.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        video.muted = true;
        pending = true; update();
        const current = ++request;
        timeout = setTimeout(() => {
          if (current !== request || !pending) return;
          pause(); failed = true;
          video.removeAttribute('src'); video.load();
          figure.classList.remove('has-frame');
          status.textContent = 'The film could not load. You can retry, or explore the equipment below.';
        }, 12000);
        try {
          await video.play();
          if (current !== request) return;
          pending = false; clearTimeout(timeout); update();
        } catch (error) {
          if (current !== request) return;
          pending = false; clearTimeout(timeout); update();
          if (fromUser || video.error) status.textContent = 'Playback is unavailable. The equipment and enquiry links remain available.';
        }
      };
      button.addEventListener('click', () => {
        if (pending || !video.paused) { userPaused = true; resume = false; pause(); }
        else play(true);
      });
      // The visible control is gone: clicking or tapping the film pauses and resumes it (the button stays for keyboards).
      // On desktop the headline sits over the film, so listen on the whole hero and ignore its links, buttons and selections.
      (figure.closest('.s-hero') || figure).addEventListener('click', (event) => {
        if (event.target.closest('a, button, input, select, textarea, label') || String(getSelection())) return;
        button.click();
      });
      video.addEventListener('playing', () => {
        if (userPaused || document.hidden || !visible) { pause(); return; }
        pending = false; clearTimeout(timeout); figure.classList.add('has-frame'); status.textContent = ''; update();
      });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => {
        pending = false; failed = true; clearTimeout(timeout); figure.classList.remove('has-frame'); update();
        status.textContent = 'The film is unavailable. You can retry, or explore the equipment below.';
      });
      const visibility = () => {
        if (!visible || document.hidden) {
          resume = resume || (!video.paused && !userPaused);
          pause();
        } else if (resume && !userPaused && (manual || allowed())) { resume = false; play(manual); }
        else if (!attempted && allowed() && document.readyState === 'complete') play();
      };
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting; visibility();
      }, { threshold: 0.15 }).observe(figure.querySelector('.ip-film-frame'));
      document.addEventListener('visibilitychange', visibility);
      const preferenceChanged = () => {
        if (!allowed() && !manual) { resume = false; pause(); }
        if (motion.matches) { manual = false; resume = false; pause(); }
      };
      motion.addEventListener('change', preferenceChanged);
      small.addEventListener('change', preferenceChanged);
      touch.addEventListener('change', preferenceChanged);
      connection?.addEventListener('change', preferenceChanged);
      figure.querySelector('.ip-film-controls').hidden = false;
      if (document.readyState === 'complete') visibility();
      else window.addEventListener('load', visibility, { once: true });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
